import { createBrowserRouter, RouterProvider, Navigate } from 'react-router'
import AuthGuard from '@/components/auth/AuthGuard'
import GuestGuard from '@/components/auth/GuestGuard'
import AdminGuard from '@/components/auth/AdminGuard'
import PageLayout from '@/components/shell/PageLayout'
import AuthPage from '@/pages/auth/AuthPage'
import StatusPage from '@/pages/status/StatusPage'
import SubscribePage from '@/pages/subscribe/SubscribePage'
import PrivacyPage from '@/pages/legal/PrivacyPage'
import TermsPage from '@/pages/legal/TermsPage'
import DataDeletionPage from '@/pages/legal/DataDeletionPage'
import DashboardPage from '@/pages/dashboard/DashboardPage'
import ConfigurationsLayout from '@/pages/configurations/ConfigurationsLayout'
import AgentsPage from '@/pages/configurations/AgentsPage'
import PromptsPage from '@/pages/configurations/PromptsPage'
import SettingsLayout from '@/pages/settings/SettingsLayout'
import AccountPage from '@/pages/settings/AccountPage'
import NotificationsPage from '@/pages/settings/NotificationsPage'
import PlatformsPage from '@/pages/settings/PlatformsPage'
import ModelPage from '@/pages/settings/ModelPage'
import DangerZonePage from '@/pages/settings/DangerZonePage'
import WorkspaceLayout from '@/pages/workspace/WorkspaceLayout'
import AgentLayout from '@/pages/workspace/AgentLayout'
import ContentLayout from '@/pages/workspace/ContentLayout'
import ProvidersLayout from '@/pages/workspace/ProvidersLayout'
import ClientSelectorPage from '@/pages/workspace/ClientSelectorPage'
import CampaignsPage from '@/pages/workspace/CampaignsPage'
import HistoryPage from '@/pages/workspace/HistoryPage'
import QueuePage from '@/pages/workspace/QueuePage'
import DirectoryPage from '@/pages/workspace/DirectoryPage'
import OutreachPage from '@/pages/workspace/OutreachPage'
import OutreachCampaignsPage from '@/pages/workspace/OutreachCampaignsPage'
import OutreachCampaignDetailPage from '@/pages/workspace/OutreachCampaignDetailPage'
import AgentPage from '@/pages/workspace/AgentPage'
import AgentSetupPage from '@/pages/workspace/AgentSetupPage'
import ChatPage from '@/pages/workspace/ChatPage'
import ConfigurePage from '@/pages/workspace/ConfigurePage'
import AdminPage from '@/pages/admin/AdminPage'

export const router = createBrowserRouter([
  {
    element: <GuestGuard />,
    children: [
      { path: '/auth', element: <AuthPage /> },
    ],
  },
  { path: '/status', element: <StatusPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/terms', element: <TermsPage /> },
  { path: '/data-deletion', element: <DataDeletionPage /> },
  { path: '*', element: <Navigate to="/" replace /> },
  { path: '/subscribe', element: <SubscribePage /> },
  {
    path: '/',
    element: <AuthGuard />,
    children: [
      {
        element: <PageLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          {
            path: 'workspace',
            element: <WorkspaceLayout />,
            children: [
              { index: true, element: <ClientSelectorPage /> },
              {
                path: 'clients/:clientId',
                children: [
                  { index: true, element: <Navigate to="agent" replace /> },
                  {
                    element: <AgentLayout />,
                    children: [
                      { path: 'agent', element: <AgentPage /> },
                      { path: 'configure', element: <ConfigurePage /> },
                      { path: 'chat', element: <ChatPage /> },
                    ],
                  },
                  {
                    element: <ContentLayout />,
                    children: [
                      { path: 'campaigns', element: <CampaignsPage /> },
                      { path: 'history', element: <HistoryPage /> },
                    ],
                  },
                  {
                    element: <ProvidersLayout />,
                    children: [
                      { path: 'directory', element: <DirectoryPage /> },
                      { path: 'outreach', element: <OutreachPage /> },
                      { path: 'outreach-campaigns', element: <OutreachCampaignsPage /> },
                      { path: 'outreach-campaigns/:campaignId', element: <OutreachCampaignDetailPage /> },
                    ],
                  },
                  { path: 'queue', element: <QueuePage /> },
                  { path: 'agent/setup', element: <AgentSetupPage /> },
                ],
              },
            ],
          },
          {
            path: 'configurations',
            element: <ConfigurationsLayout />,
            children: [
              { index: true, element: <Navigate to="agents" replace /> },
              { path: 'agents', element: <AgentsPage /> },
              { path: 'prompts', element: <PromptsPage /> },
            ],
          },
          {
            path: 'settings',
            element: <SettingsLayout />,
            children: [
              { index: true, element: <Navigate to="model" replace /> },
              { path: 'account', element: <AccountPage /> },
              { path: 'notifications', element: <NotificationsPage /> },
              { path: 'platforms', element: <PlatformsPage /> },
              { path: 'model', element: <ModelPage /> },
              { path: 'danger-zone', element: <DangerZonePage /> },
            ],
          },
          {
            path: 'admin',
            element: <AdminGuard />,
            children: [
              { index: true, element: <AdminPage /> },
            ],
          },
        ],
      },
    ],
  },
])

export default function App() {
  return <RouterProvider router={router} />
}
